import type { StatusTone } from "@/shared/components/StatusTag";
import type { TaskPriority, TaskStatus, TaskTargetType } from "./types";

export const TASK_TARGET_TYPE_OPTIONS: { value: TaskTargetType; label: string }[] = [
	{ value: "LOCATION", label: "Joylashuv" },
	{ value: "PLANT", label: "Ekin" },
];

export const TASK_STATUS_OPTIONS: { value: TaskStatus; label: string }[] = [
	{ value: "DRAFT", label: "Qoralama" },
	{ value: "PENDING", label: "Kutilmoqda" },
	{ value: "IN_PROGRESS", label: "Jarayonda" },
	{ value: "COMPLETED", label: "Bajarildi" },
	{ value: "CANCELLED", label: "Bekor qilindi" },
];

/** Statuses selectable at task creation — DRAFT (hidden from the brigade) or PENDING (visible immediately). */
export const CREATE_TASK_STATUS_OPTIONS = TASK_STATUS_OPTIONS.filter(
	(o) => o.value === "DRAFT" || o.value === "PENDING"
);

export const TASK_STATUS_COLORS: Record<TaskStatus, StatusTone> = {
	DRAFT: "warning",
	PENDING: "default",
	IN_PROGRESS: "processing",
	COMPLETED: "success",
	CANCELLED: "error",
};

export const TASK_PRIORITY_OPTIONS: { value: TaskPriority; label: string }[] = [
	{ value: "LOW", label: "Past" },
	{ value: "MEDIUM", label: "O'rta" },
	{ value: "HIGH", label: "Yuqori" },
	{ value: "URGENT", label: "Shoshilinch" },
];

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
	LOW: "Past",
	MEDIUM: "O'rta",
	HIGH: "Yuqori",
	URGENT: "Shoshilinch",
};
